import { commonOpenGraphMeta, defaultMetaData } from "@/lib/constants/common";
import { getLanguageAlternates } from "@repo/lib/helpers";
import { getCategoryBySlug } from "@repo/server-actions/category";

export async function generateCategoryMetadata({
  locale,
  slug,
  searchParams,
  routingLocales,
  pathname,
}) {
  const { sort, page, ...filters } = searchParams;
  const sortParam = typeof sort === "string" ? sort : undefined;
  const pageNumber = typeof page === "string" ? Number(page) : 1;
  const filterParams = new URLSearchParams(filters).toString();
  const meta = await getCategoryBySlug(
    slug,
    sortParam,
    pageNumber,
    filterParams,
    locale
  );
  const content = meta?.content || [];
  const seo = content[0]?.seo || {};

  const title =
    locale === "ar" ? seo?.ar?.title : seo?.en?.title || defaultMetaData?.title;

  const description =
    locale === "ar"
      ? seo?.ar?.description
      : seo?.en?.description || defaultMetaData?.description;

  const languages = await getLanguageAlternates({ pathname, routingLocales });

  return {
    title,
    description,
    openGraph: {
      title,
      description,
      ...commonOpenGraphMeta,
    },
    alternates: {
      canonical: "./",
      languages,
    },
    ...(Object.keys(searchParams).length !== 0 && {
      robots: "noindex, follow",
    }),
  };
}
